module.exports = __webpack_public_path__ + "static/media/mode-9.23feb464.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-9.svg
// module id = 982
// module chunks = 2